import fetch from '@/utils/fetch';
import filterNull from '@/utils/filterNull';
import moment from 'moment';
import { defaultPageSize } from './orderConf';

const model = {
  state: {
    /**
     * 外卖订单
     */
    // 同城配送方式
    filter: {
      orderId: '', // 订单号默认值
      receiverPhone: '', // 买家默认值
      dispatchMethod: 1, // 默认同城配送
      skuName: '', // 商品名称默认值
      status: -1, // 订单状态默认全部
      orderTime: [moment().add(-7, 'day').startOf('day'), moment().endOf('day')],
      orderTimeMonth: moment().subtract(1, 'months'),
      page: 1,
      pageSize: defaultPageSize,
      orderType: -1, // 订单类型，默认是全部
      orderFlag: -1,
      // isAppointment: -1, // 默认全部是否预约
      appointmentTime: [],
      companyType: -1,
      shopName: '',
      companyName: '',
      orderChannel: -1,
      orderBy: '',
      unionShopId: 0,
      cityCodes: [],
      subShopName: '',
      subShopId: '',
      subShopId: '',
      companyId: '',
      showTest: 0,
      cabinetStatus: -1,
    },
    listTotal: 0,
    isRedelivery: false,
    statusCount: {},
    goodsSource: [], // 商品的列表数据
    goodsLoading: true, // 商品列表的loading状态
    logisticsData: [], // 商品得物流信息
    logisticsLoading: true, // 商品物流信息的loading状态
    subStoreList: [],
    productTypes: [],
    printData: { sku_list: [] }, // 打印内容
    cancelLoading: false, // 取消订单弹框确认按钮loading状态
    /**
     * 堂食订单
     */
    stayOrderStatusSource: [
      { name: '全部', id: 'all', value: -1 },
      { name: '待支付', id: 'toPaid', value: 1 },
      { name: '待接单', id: 'toShipped', value: 2 },
      { name: '已完成', id: 'done', value: 3 },
      { name: '已取消', id: 'canceled', value: 4 },
    ],
    stayFilter: {
      orderId: '', // 订单号默认值
      seat: '', // 商品名称默认值
      orderTime: [moment().startOf('day'), moment().endOf('day')],
      orderStatus: -1, // 订单状态默认全部
    },
    stayStatus: {},
    stayGoodsSource: [], // 商品的列表数据
    stayGoodsLoading: true, // 商品列表的loading状态
    stayPageSize: defaultPageSize, // 每页默认显示10条
    stayCurPage: 1, // 默认展示第一页
    // subStoreList: [],
    stayPrintData: { sku_list: [] }, // 打印内容
    stayCancelLoading: false, // 取消订单弹框确认按钮loading状态
    // 在线发货快递
    onLineExpress: {},
    expressList: {},
    // 打包单
    packOrderList: [], // 商品的列表数据
    packOrderTotal: 0, // 商品的列表数据
    subShopOption: [],
    shopList: [],
    companyList: [],
    packLoading: true, // 打包列表的loading状态
    packPageSize: defaultPageSize, // 每页默认显示10条
    packCurPage: 1, // 默认展示第一页
    // 商圈列表
    bdList: [],

    // 展示近期或历史订单明细
    isRecentOrder: true,
  },
  reducers: {
    setState(state, partialState) {
      return { ...state, ...partialState };
    },
  },
  actions: ({ dispatch: { OptOrderList }, getState }) => ({
    // 顶部筛选选择
    changeFilterState(params) {
      const { filter } = getState().OptOrderList;
      const mergeParam = { ...filter, ...params };
      OptOrderList.setState({
        filter: mergeParam,
      });
    },
    // 获取订单列表
    async querySource(args = {}) {
      const { isRecentOrder } = getState().OptOrderList;
      const { filter } = getState().OptOrderList;
      const params = filterNull({ ...filter, ...args });
      // 删除params无用字段
      if (isRecentOrder) {
        if (params.orderTime && params.orderTime.length) {
          params.startTime = Math.round(params.orderTime[0].valueOf() / 1000);
          params.endTime = Math.round(params.orderTime[1].valueOf() / 1000);
          delete params.orderTime;
          delete params.orderTimeMonth;
        }
      } else if (params.orderTimeMonth) {
        params.startTime = params?.orderTimeMonth?.startOf('month').unix();
        params.endTime = params?.orderTimeMonth?.endOf('month').unix();
        delete params.orderTime;
        delete params.orderTimeMonth;
      }
      if (params.appointmentTime && params.appointmentTime.length) {
        params.deliveryBeginTime = Math.round(params.appointmentTime[0].valueOf() / 1000);
        params.deliveryEndTime = Math.round(params.appointmentTime[1].valueOf() / 1000);
        delete params.appointmentTime;
      }
      const { shop_id, sub_shop_id, shopType } = getState().basic;
      OptOrderList.setState({ goodsLoading: true });

      const changeParams = {
        shopId: shop_id,
        subShopId: sub_shop_id,
        subStatus: shopType === 'main' ? 1 : 0,
        ...params,
        cityCodes: params?.cityCodes?.join(','),
        businessDistrictIds: params?.businessDistrictIds?.join(','),
      };
      // 聚合平台和丰食shopid问题
      changeParams.unionShopId = shop_id;
      changeParams.shopId = 0;

      if (!changeParams.dispatchMethod) {
        delete changeParams.shopName;
        delete changeParams.subShopName;
        delete changeParams.companyName;
      }
      if (!isRecentOrder && changeParams.dispatchMethod) {
        delete changeParams.receiverPhone;
      }

      const data = await fetch('/saasmerchant/web/order/querylist', {
        params: {
          ...changeParams,
          shopId: filter.shopId,
          subShopId: filter.subShopId,
          companyId: filter.companyId,
        },
      });
      OptOrderList.setState({ goodsLoading: false });
      if (data && data.list) {
        OptOrderList.setState({
          goodsSource: data.list,
          statusCount: data.count || {},
          listTotal: data.total,
        });
      }
    },
    /**
     * 外卖订单
     */
    setPagination(curr) {
      OptOrderList.setState({ currPage: curr });
    },
    setIsRedelivery(value) {
      OptOrderList.setState({ isRedelivery: value });
    },
    async exportOrder() {
      const { isRecentOrder } = getState().OptOrderList;
      const { shopType, shop_id, sub_shop_id } = getState().basic;
      const { filter } = getState().OptOrderList;
      const mergeParams = filterNull({
        ...filter,
        shopId: shop_id,
        subShopId: sub_shop_id,
        subStatus: shopType === 'main' ? 1 : 0,
        cityCodes: filter?.cityCodes.join(','),
        businessDistrictIds: filter?.businessDistrictIds?.join(','),
      });

      // 删除params无用字段
      if (isRecentOrder && mergeParams.orderTime && mergeParams.orderTime.length) {
        mergeParams.startTime = Math.round(mergeParams.orderTime[0].valueOf() / 1000);
        mergeParams.endTime = Math.round(mergeParams.orderTime[1].valueOf() / 1000);
        delete mergeParams.orderTime;
        delete mergeParams.orderTimeMonth;
      }
      if (!isRecentOrder && mergeParams.orderTimeMonth) {
        mergeParams.startTime = mergeParams.orderTimeMonth?.startOf('month').unix();
        mergeParams.endTime = mergeParams.orderTimeMonth?.endOf('month').unix();
        mergeParams.searchMonth = mergeParams.orderTimeMonth?.format('YYYYMM');
        delete mergeParams.orderTime;
        delete mergeParams.orderTimeMonth;
      }
      if (mergeParams.appointmentTime && mergeParams.appointmentTime.length) {
        mergeParams.deliveryBeginTime = Math.round(mergeParams.appointmentTime[0].valueOf() / 1000);
        mergeParams.deliveryEndTime = Math.round(mergeParams.appointmentTime[1].valueOf() / 1000);
        delete mergeParams.appointmentTime;
      }
      mergeParams.unionShopId = shop_id;
      mergeParams.shopId = 0;

      if (!mergeParams.dispatchMethod) {
        delete mergeParams.shopName;
        delete mergeParams.subShopName;
        delete mergeParams.companyName;
      }
      if (!isRecentOrder && mergeParams.dispatchMethod) {
        delete mergeParams.receiverPhone;
      }
      const data = await fetch('/saasmerchant/web/order/crm/export', {
        type: 'POST',
        useJson: true,
        params: {
          ...mergeParams,
          export: 1,
          shopId: filter.shopId,
          subShopId: filter.subShopId,
          companyId: filter.companyId,
          cityCodes: filter.cityCodes,
          businessDistrictIds: filter.businessDistrictIds,
          status: [filter.status],
        },
      });
      return data;
    },
    // 自提商品核销码
    async takeOverSelfList(params) {
      const { shopType, sub_shop_id, shop_id } = getState().basic;
      const mergeParams = {
        subStatus: shopType === 'main' ? 1 : 0,
        shopId: shop_id,
        subShopId: sub_shop_id,
      };
      const data = await fetch('/saasmerchant/web/order/takeover', {
        type: 'POST',
        params: {
          ...params,
          ...mergeParams,
        },
        useJson: true,
      });
      return data;
    },
    // 自提接单
    async selfOrderReceive(params) {
      const { sub_shop_id } = getState().basic;
      const data = await fetch('/saasmerchant/web/order/accepted', {
        type: 'POST',
        params: {
          ...params,
          subShopId: sub_shop_id,
        },
        useJson: true,
      });
      return data;
    },
    // 商家自己配送完成
    async selfDeliveryDone(params) {
      const { shopType, sub_shop_id, shop_id } = getState().basic;
      const mergeParam = {
        subStatus: shopType === 'main' ? 1 : 0,
        subShopId: sub_shop_id,
        shopId: shop_id,
      };
      const data = await fetch('/saasmerchant/web/order/finishcaterorder', {
        type: 'POST',
        params: { ...mergeParam, ...params },
        useJson: true,
      });
      return data;
    },
    async getLogisticsInfo(params) {
      OptOrderList.setState({ logisticsLoading: true });
      const data = await fetch('/saasmerchant/web/order/deliveryinfo', { params, useJson: true });
      OptOrderList.setState({ logisticsLoading: false });
      const result = data.length && data[0].traces ? data[0].traces : [];
      OptOrderList.setState({ logisticsData: result });
    },
    async cancelOrder(params) {
      OptOrderList.setState({ cancelLoading: true });
      const { sub_shop_id, shopType } = getState().basic;
      const result = await fetch('/saasmerchant/web/order/ordercancel', {
        type: 'POST',
        useJson: true,
        params: { subStatus: shopType === 'main' ? 1 : 0, subShopId: sub_shop_id, ...params },
      });
      OptOrderList.setState({ cancelLoading: false });
      return result;
    },
    async confirmSend(params) {
      const { sub_shop_id, shopType } = getState().basic;
      const data = await fetch('/trade/order/bindexpressno', {
        type: 'POST',
        params: { sub_status: shopType === 'main' ? 1 : 0, sub_shop_id, ...params },
      });
      return data;
    },
    async confirmCitySend(params) {
      const { sub_shop_id, shopType } = getState().basic;
      const data = await fetch('/trade/order/clsprebook', {
        type: 'POST',
        params: { ...params, sub_shop_id, sub_status: shopType === 'main' ? 1 : 0 },
      });
      return data;
    },
    // 确认已退款标记
    async ensureRefund(orderId) {
      const { shop_id, sub_shop_id } = getState().basic;
      const params = { shopId: shop_id, orderId, subShopId: sub_shop_id };
      const data = await fetch('/saasmerchant/web/order/refundconfirm', { type: 'POST', params });
      return data;
    },
    // 提前应约操作
    async reqAdvanceAppointment(order_id) {
      const { shop_id, sub_shop_id } = getState().basic;
      const params = {
        orderId: order_id,
        shopId: shop_id,
        subShopId: sub_shop_id,
      };
      const data = await fetch('/saasmerchant/web/order/tobeaccepted', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        return data;
      }
      return null;
    },
    // 接单操作
    async receiveOrder(orderId, callback) {
      const { shop_id, sub_shop_id } = getState().basic;
      const params = { shopId: shop_id, orderId, subShopId: sub_shop_id };
      const data = await fetch('/saasmerchant/web/order/accepted', {
        type: 'POST',
        params,
        useJson: true,
      });
      if (data) {
        callback && callback();
        return data;
      }
      return false;
    },
    async getProductType(params) {
      const result = await fetch('/saasmerchant/web/express/getproducttype', {
        type: 'POST',
        params,
        useJson: true,
      });
      result && OptOrderList.setState({ productTypes: result });
    },
    /**
     * 堂食订单
     */
    setStayPagination(curr) {
      OptOrderList.setState({ stayCurPage: curr });
    },
    onStayShowSizeChange(stayCurPage, stayPageSize) {
      OptOrderList.setState({ stayCurPage, stayPageSize });
    },
    setStayFilter(params) {
      OptOrderList.setState({ stayFilter: params });
    },
    resetStayFilter() {
      OptOrderList.setState({
        stayFilter: {
          orderId: '', // 订单号默认值
          seat: '', // 买家默认值
          orderTime: [moment().startOf('day'), moment().endOf('day')],
          orderStatus: -1, // 订单状态默认全部
        },
      });
    },
    async onDelivery(params) {
      const { isRedelivery } = getState().OptOrderList;
      const data = await fetch(
        isRedelivery ? '/trade/order/redelivery' : '/saasmerchant/web/order/senddelivery',
        {
          // 接口重构，字段变化，之前的逻辑太复杂，不好搞，时间紧张，故出此下策
          params: {
            ...params,
            deliveryInfo: params.deliveryInfo ? JSON.parse(params.deliveryInfo) : [],
            subStatus: 1,
          },
          type: 'POST',
          useJson: true,
        },
      );
      if (data) {
        OptOrderList.setState({ isRedelivery: false });
      }
      return data;
    },
    async getOnlineExpress(params) {
      const onLineExpress = await fetch('/saasmerchant/web/express/getonlineexpress', {
        params,
      });
      onLineExpress && OptOrderList.setState({ onLineExpress });
    },
    // 获取快递列表
    async getExpressList(params) {
      const expressList = await fetch('/saasmerchant/web/express/getofflineexpress', {
        params,
      });
      expressList && OptOrderList.setState({ expressList });
    },
    setPackPagination(curr) {
      OptOrderList.setState({ packPerPage: curr });
    },
    onPackShowSizeChange(packPerPage, packPageSize) {
      OptOrderList.setState({ packPerPage, packPageSize });
    },
    // 获取商圈列表
    async getBDList(params) {
      const bdList = await fetch(
        '/saasmerchant/fsarea/businessDistrict/getBusinessDistrictIdByNameAndPermission',
        {
          params,
        },
      );
      OptOrderList.setState({ bdList: bdList || [] });
      return bdList;
    },
    clearBDList() {
      OptOrderList.setState({ bdList: [] });
    },
    setSubShopOption(data) {
      OptOrderList.setState({ subShopOption: data || [] });
    },
    setShopList(data) {
      OptOrderList.setState({ shopList: data || [] });
    },
    setCompanyList(data) {
      OptOrderList.setState({ companyList: data || [] });
    },
    // 切换近期或历史订单查询
    changeIsRecentOrder(isRecentOrder) {
      OptOrderList.setState({ isRecentOrder });
      if (!isRecentOrder) {
        OptOrderList.setState({
          goodsSource: [],
          statusCount: {},
          listTotal: 0,
        });
        return;
      }
      OptOrderList.querySource();
    },
    // 清空列表
    clearGoodsSource() {
      OptOrderList.setState({
        goodsSource: [],
        statusCount: {},
        listTotal: 0,
      });
    },
    // 发货异常监控
    async getFailDeliveryCount() {
      const data = await fetch('/saasmerchant/web/order/queryfailcount');
      return data;
    },

    async getCityList(params) {
      const data = await fetch('/saasmerchant/web/auth/areaModuleWithPermission', {
        params,
      });

      OptOrderList.setState({ cityOptions: data || [] });
    },
  }),
};

export default model;
